import { render, staticRenderFns } from "./modalApproveCarrier.vue?vue&type=template&id=410f6c16&scoped=true"
import script from "./modalApproveCarrier.vue?vue&type=script&lang=js"
export * from "./modalApproveCarrier.vue?vue&type=script&lang=js"
import style0 from "./modalApproveCarrier.vue?vue&type=style&index=0&id=410f6c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f6c16",
  null
  
)

export default component.exports